import React from 'react'
import { Button } from '@mui/material'
import { getQueryMassUpdate } from 'entity/LaudoVisita/components/LaudoVisitaConsultaRelatorios/functions'

export default function FilterButtonAutomatizador({
    filters,
    setMsgFilter,
    setLaudos,
    setFiltersOld,
    globalLoading,
    setGlobalLoading
}) {

    const buscarLaudos = async () => {
        setMsgFilter("")

        if (!filters.cliente) {
            setMsgFilter("Selecione um cliente")
            return
        }

        if (!filters.dataInicio || !filters.dataFim) {
            setMsgFilter("Informe as datas de início e fim")
            return
        }

        setGlobalLoading(true)

        try {
            let query = getQueryMassUpdate(filters.cliente, filters.status, filters.dataInicio, filters.dataFim)

            const observer = query.onSnapshot(
                async (querySnapshot) => {
                    const resultados = []
                    querySnapshot.forEach((doc) => {
                        const data = doc.data()
                        data.uid = doc.id
                        resultados.push(data)
                    })

                    setLaudos(resultados)
                    setFiltersOld(filters)
                    setGlobalLoading(false)
                },
                (error) => {
                    console.error('Erro ao buscar laudos: ', error)
                    setMsgFilter("Erro ao buscar laudos. Tente novamente.")
                    setLaudos([])
                    setGlobalLoading(false)
                }
            )

            return () => {
                if (observer) observer()
            }

        } catch (error) {
            console.error('Erro ao criar query:', error)
            setMsgFilter("Erro ao buscar laudos. Tente novamente.")
            setLaudos([])
            setGlobalLoading(false)
        }
    }

    return (
        <Button
            data-filter-button-automatizador
            variant="contained"
            color="primary"
            onClick={buscarLaudos}
            disabled={globalLoading}
        >
            {globalLoading ? "Buscando..." : "Buscar Laudos"}
        </Button>
    )
}